import React from 'react'

import triggerEvent from 'utils/dataLayer'
import config from 'config'

const { assets_url: assetsUrl } = config

const AptitudeBanner = ({ onLoad }) => (
  <div className="aptitude-banner">
    <a href="/aptitude_test" onClick={() => { triggerEvent('ga/home/aptitudetest') }}>
      <picture onLoad={onLoad}>
        <source media="(min-width: 1440px)" srcSet={`${assetsUrl}/assets/img/aptitude/banner-desktop-hd.jpg`} />
        <source media="(min-width: 1024px)" srcSet={`${assetsUrl}/assets/img/aptitude/banner-desktop-lg.jpg`} />
        <source media="(min-width: 768px)" srcSet={`${assetsUrl}/assets/img/aptitude/banner-desktop-md.jpg`} />
        <source media="(min-width: 576px)" srcSet={`${assetsUrl}/assets/img/aptitude/banner-mobile-lg.jpg`} />
        <img src={`${assetsUrl}/assets/img/aptitude/banner-mobile-md.jpg`} className="img-responsive" alt="Aptitude Test Banner" />
      </picture>
    </a>
    <style jsx>
      {`
        .aptitude-banner {
          :global(img) {
            width: 100%;
          }
        }
      `}
    </style>
  </div>
)

export default AptitudeBanner
